
<template>
    <b-modal id="modal_form"
             ref="modal_form"
             centered
             :title="modal_titulo"
             :ok-title="modal_botao"
             close-title="Fechar"
             cancel-title="Cancelar"
             :ok-disabled=form.errors.any()
             v-model="showModal"
             @ok="handleOk">

        <form @submit.stop.prevent="handleOk"
              @keydown="form.errors.clear($event.target.name)">
            <label>Insira o código enviado ao E-mail:</label>
            <b-form-input type="text"
                          placeholder="Código"
                          v-model="form.cod"
                          name="nome">
            </b-form-input>
            <b-form-feedback v-text="form.errors.get('nome')" v-if="form.errors.has('nome')"></b-form-feedback>

        </form>

        <div slot="modal-footer" class="w-100">
            <div class="float-left">
                <spinner v-if="loading" message="Processando..."></spinner>
            </div>
            <div class="float-right">
                <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
                <b-btn @click="closeModal()" variant="secondary">
                    Fechar
                </b-btn>
                <b-btn @click="handleOk($event)" variant="secondary" :disabled="isDisabled">
                    Enviar
                </b-btn>
            </div>
        </div>

    </b-modal>
</template>
<script>
import AvisoErros from '../components/AvisoErros'


export default {
components: {
    AvisoErros,
},
props: {
    metodo: {type: Function},
    tabela: '',
    rota: ''
},
data () {
    return {
      errors_array: [],
      dataExport: [],
      modal_titulo: '',
      modal_botao: '',
      modal_acao: '',
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      isFullscreen: false,
      optionsLivStatus: [],
      form: new Form({
          cod: '',
                   }),
        helpForm: new Form({ statusRecord: [], params: [] }),
  css: {
      loadingClass: 'loading',
      ascendingIcon: 'glyphicon glyphicon-chevron-up',
      descendingIcon: 'glyphicon glyphicon-chevron-down',
      handleIcon: 'glyphicon glyphicon-menu-hamburger',
  },
  moreParams: {}
   }
},

methods: {
    handleOk(e)
    {
        e.preventDefault();
        if(this.modal_acao=="i")
        {
           this.onStore();
        }
        else
        {
            this.onUpdate(this.form.pais_id);
        }
    },
    onCreate ()
    {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Token Email";
      this.modal_botao = "Enviar";
      this.modal_acao = "i";
      this.form.reset();
      this.errors_array = '';
      this.errors_array = [];
      this.form.status = 1;
      this.$refs.modal_form.show();
    },
    onEdit (data, index, id)
    {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar";
      this.modal_botao = "Alterar";
      this.modal_acao = "u";
      this.form.reset();
      this.errors_array = '';
      this.errors_array = [];
      this.$refs.modal_form.show();
    },
    onStore()
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.post('/api/usuario/token/check').then(response =>
        {
            this.helpForm.get('/api/usuario').then(resp => {
                   // Obrigatório existir
                      this.$store.commit('setApiVersion', resp.user.unidade_active.api_version);
                      this.$store.commit('setBcliente', resp.user.bcliente_active);
                      this.$store.commit('setUser', resp);
                      if (this.$store.getters.logged.user.unidade_active != undefined) {
                                    this.$store.commit('setUnidade', resp.user.unidade_active);
                      }
                      else {
                          this.$store.commit('setUnidade', null);
                      }
                      if (resp.user.bcliente_active.b_config_blogistic.cor_sistema == "1") {
                          this.site_header_color = "";
                      }
                      else if (resp.user.bcliente_active.b_config_blogistic.cor_sistema == "2") {
                          this.site_header_color = "site-header-red";
                      }
                      else if (resp.user.bcliente_active.b_config_blogistic.cor_sistema == "3") {
                          this.site_header_color = "site-header-blue";
                      }
                      //Dados Free
                      this.$store.commit('BPlano', resp.user.bcliente_active.b_bcliente_bplano);
                      // Local
                      this.favorito = resp.favorito;
                      this.tarefa = resp.tarefa;
                      this.changelog = resp.changelog;
                      if (resp.user.pessoa_fisica !== null) {
                          if (resp.user.pessoa_fisica == null) {
                              this.url_img_profile = "images/avatar/avatar-1-32.png";
                          }
                          else {
                              this.url_img_profile = resp.user.pessoa_fisica.url_img;
                          }
                      }
                      else {
                          this.url_img_profile = "images/avatar/avatar-1-32.png";
                      }
                      this.$router.push('/dashboard');
                    })
                        .catch(errors => {
                        new ReturnApi(errors, this);

                    });
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    onUpdate(id)
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.patch('/api/'+this.rota+'/update/'+id).then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    onError(response) {
        new ReturnApi(response.response, this, true, true, false);
    },
    closeModal() {
        this.showModal = false;
        this.$parent.$data.loading = false;
        this.$parent.$data.isDisabled = false;
    },
},
computed: {
    vuetableFilterRow: {
      get () {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
        get() {
            return this.$store.getters.isloaded;
        }
    }
}
}
</script>
